import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-container">
      <h1 className="home-title">Welcome to Eventify</h1>
      <p className="home-description">
        Plan, organize, and manage your events seamlessly. Get started now!
      </p>
      <div className="home-button-container">
        <div className="top-buttons">
          <Link to="/login" className="button login-button">
            Login
          </Link>
          <Link to="/signup" className="button signup-button">
            Signup
          </Link>
        </div>
        <div className="bottom-button">
          <Link to="/real-time-attendees" className="button guest-button">
            Sign in as Guest
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
